import ResetPassword from "./ResetPassword.container";

export default ResetPassword;